var _g, _text, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "hover",
    width: 200,
    height: 200,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "triangulo1",
    fill: "none",
    stroke: "#14d1b280",
    strokeWidth: 0.5,
    points: "24.9,6.1 30.9,6.1 44.9,31.1 40.9,37.1 14.9,37.1 10.9,31.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "triangulo2",
    fill: "none",
    stroke: "#14d1b280",
    strokeWidth: 0.2,
    points: "30.9,15.1 19.9,35.1 16.9,31.1 27.9,9.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "triangulo2",
    fill: "none",
    stroke: "#14d1b280",
    strokeWidth: 0.2,
    points: "34.9,23.1 28.9,35.1 25.9,29.1 31.9,17.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "triangulo2",
    fill: "none",
    stroke: "#14d1b280",
    strokeWidth: 0.2,
    points: "38.9,30.1 36.9,35.1 34.9,30.1 36.9,25.1"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "loading",
    x: 10,
    y: 50,
    fill: "#ffffff"
  }, "-LOADING-")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .loading{\n        font-family:arial;\n        font-size:7px;\n        animation:blink .9s ease-in-out infinite;\n      }\n      .triangulo1{\n        stroke-dasharray:17;\n        animation:dash 6s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n      }\n      .triangulo2{\n      stroke-dasharray:34;\n      animation:dash 2.5s cubic-bezier( 0.95 ,0.63, 0.04, 0.35) infinite,pinnako 5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n\n      }\n\n      @keyframes dash{\n        to{\n          stroke-dashoffset:136;\n        }\n      }\n      @keyframes blink{\n        50%{\n          opacity:0;\n        }\n      }\n      @keyframes pinnako{\n        0{\n          fill:none;\n        }\n        50%{\n          fill:#14D1B230;\n        }\n        0{\n          fill:none;\n        }\n      }\n")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6aed72b6.svg";
export { ForwardRef as ReactComponent };